import React from 'react'
import RoundBlueButton from '../BorderButton/round-blue-button'

import 'react-bootstrap-toggle/dist/bootstrap2-toggle.css'
import { Bootstrap2Toggle } from 'react-bootstrap-toggle'
import ReactTooltip from 'react-tooltip'
import Select from 'react-select'
import ACLCheckPermission from '../ACLCheckPermission'

const selectStyles = {
    menuPortal: base => ({ ...base, zIndex: 9999 }),
    option: (styles, { data, isSelected }) => {
        const isDefault = data.roleType === 'DEFAULT'
        const color = isDefault ? 'green' : 'black'
        return {
            ...styles,
            fontFamily: 'Rubik',
            //fontWeight: isDefault ? 'bold' : null,
            fontStyle: isDefault ? 'underline' : 'normal',
            color: isSelected ? 'black' : isDefault ? '#666666' : '#666666',
            //backgroundColor: isSelected ? "alpha(opacity=10)"  :  null,
            cursor: 'pointer'
        }
    }
}

const SaveButton = ({ onClick, disabled }) => (
    <RoundBlueButton data-tip data-for="saveBtnTooltip" disabled={disabled} onClick={onClick} icon={<i className="fa fa-floppy-o" />} />
)
const RemoveButton = ({ onClick, disabled }) => (
    <RoundBlueButton data-tip data-for="deleteBtnTooltip" disabled={disabled} onClick={onClick} icon={<i className="fa fa-trash" />} />
)

const Row = ({ roles, showEdit, row, onchange, index, onSave, onRemove }) => (
    <tr className={`audience-list audience-list--row }`}>
        <td className="audience-list audience-list--audience">
            <input
                type="email"
                disabled={!row.new}
                className="form-control"
                id="username"
                placeholder="email"
                value={row.username}
                onChange={event => onchange(event, row, index)}
            />
        </td>
        <td className="audience-list audience-list--audience">
            <input type="text" className="form-control" id="name" value={row.name} placeholder="name" onChange={event => onchange(event, row, index)} />
        </td>
        <td className="audience-list audience-list--audience">
            <input
                type="text"
                className="form-control"
                id="familyName"
                placeholder="family name"
                value={row.familyName}
                onChange={event => onchange(event, row, index)}
            />
        </td>
        <td className="audience-list audience-list--audience" style={{}}>
            {/* 
                Portaling - 

                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                menuPortalTarget={document.body}
                menuPosition={'absolute'}
                menuPlacement={'auto'}

                this will enable select popup to work in modals and divs with z-indexes. Also it can set auto 
                positioning on top or bottom of the select

                onChange will simulate an Event Object, we need id and target props
            */}

            <Select
                styles={selectStyles}
                menuPortalTarget={document.body}
                menuPosition={'absolute'}
                menuPlacement={'auto'}
                key={'roles_' + row.username}
                placeholder="Search a role..."
                options={roles}
                id="roleId"
                value={roles.find(e => e.roleId === row.roleId)}
                onChange={event => {
                    let e = { target: { value: event.roleId, id: 'roleId' } }
                    onchange(e, row, index)
                }}
                getOptionLabel={option => option['roleName']}
                getOptionValue={option => option['roleId']}
            />
        </td>
        <td className="audience-list audience-list--size" style={{ padding: '10px' }}>
            <Bootstrap2Toggle
                onClick={value => {
                    let event = { target: { id: 'active', value: value } }
                    row.active = !row.active
                    onchange(event, row, index)
                }}
                on={<span>ON</span>}
                off={<span>OFF</span>}
                size="xs"
                offstyle="secondary"
                active={row.active}
            />
        </td>
        {showEdit && (
            <td className="audience-list audience-list--edit">
                <div className="action-wrapper" style={{ justifyContent: 'flex-end' }}>
                    <ACLCheckPermission api="/user" method="PATCH">
                        <ReactTooltip id="saveBtnTooltip" type="dark" effect="solid">
                            <span>Save user</span>
                        </ReactTooltip>
                        <SaveButton disabled={row.username === '' || row.roleId === null} onClick={() => onSave(row, index)} />
                    </ACLCheckPermission>
                    &#160;
                    <ACLCheckPermission api="/user" method="DELETE">
                        <ReactTooltip id="deleteBtnTooltip" type="dark" effect="solid">
                            <span>Delete user</span>
                        </ReactTooltip>
                        <RemoveButton disabled={row.new} onClick={() => onRemove(row, index)} />
                    </ACLCheckPermission>
                </div>
            </td>
        )}
    </tr>
)

export default Row
